<template>
  <div>
    <div class="literacy-content">
      <div class="literacy-head">
        <p class="literacy-number">5</p>
        <p class="cabin-family bold">How would a decline in the value of your investments
        affect you?</p>
      </div>

      <div class="literacy-body">
        <div class="form-check">
          <input class="form-check-input" value="A" v-model="q5" type="radio"
          id="radio1">
          <label class="form-check-label">I am not willing to accept declines in the value of my
          investmentas capital preservation is my primary objective.</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" value="B" v-model="q5" type="radio"
          id="radio1">
          <label class="form-check-label">I am willing to accept some declines, but I am not
          comfortable with moderate to extreme drops in the value of my investments.</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" value="C" v-model="q5" type="radio"
          id="radio1">
          <label class="form-check-label">I am willing to accept moderate declines, but I am
          not comfortable with extreme drops in the value of my investments.</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" value="D" v-model="q5" type="radio"
          id="radio1">
          <label class="form-check-label">I am prepared to take losses and large fluctuations in
          the value of my investments in order to maximise my long term returns.</label>
        </div>
      </div>

      <div class="literacy-footer text-center">
        <button class="btn primary-btn btn-block" :disabled="isDisabled" @click="next">Next</button>
        <p class="cabin-family bold mt-2" @click="previous">Previous</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      if (!this.q5) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      q5: '',
    };
  },
  methods: {
    next() {
      this.$emit('next', { q5: this.q5 });
    },
    previous() {
      this.$emit('previous');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>

</style>
